import { render } from "./RedrawNotes.vue?vue&type=template&id=4f6cc232&scoped=true"
import script from "./RedrawNotes.vue?vue&type=script&lang=js"
export * from "./RedrawNotes.vue?vue&type=script&lang=js"

import "./RedrawNotes.vue?vue&type=style&index=0&id=4f6cc232&scoped=true&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6cc232"]])

export default __exports__